import { render, staticRenderFns } from "./standardlist.vue?vue&type=template&id=7b9ecafa&scoped=true"
import script from "./standardlist.vue?vue&type=script&lang=js"
export * from "./standardlist.vue?vue&type=script&lang=js"
import style0 from "./standardlist.vue?vue&type=style&index=0&id=7b9ecafa&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ecafa",
  null
  
)

export default component.exports